export const products = {
  hero: {
    home: 'Accueil',
    products: 'Produits',
    title: 'Solutions de Filtration & Purification',
    subtitle: 'Gamme complète de produits de filtration industrielle provenant des fabricants leaders mondiaux, assurant qualité, performance et fiabilité pour vos opérations',
  },
  partners: {
    clickToView: 'Cliquez pour voir les produits et solutions',
    industriesServed: 'Industries Desservies',
    keyBenefits: 'Avantages Clés',
    productCategories: 'Catégories de Produits',
    products: 'Produits',
    viewProducts: 'Voir les Produits',
    featuredProducts: 'Produits en Vedette',
    viewDetails: 'Voir les Détails',
    qualitySelectionTitle: 'Processus de Sélection Qualité',
    qualitySelectionDesc: 'Chaque partenaire est soigneusement sélectionné sur la base de l\'excellence technologique, de la qualité des produits, de la disponibilité mondiale et des performances industrielles éprouvées. Nous veillons à ce que vous receviez les meilleures solutions pour vos besoins spécifiques.',
    requestConsultation: 'Demander une Consultation Produit',
  },
  partnerData: {
    sagisaDescription: 'Fabricant leader en ingénierie de processus et systèmes de filtration et de media. Sagisa fournit des solutions complètes incluant des boîtiers filtrants, des systèmes et media d\'osmose inverse, et des équipements de traitement d\'eau industriels pour diverses applications.',
    sagisaBenefit1: 'Systèmes et médias de filtration complets',
    sagisaBenefit2: 'Expertise en technologie RO',
    sagisaBenefit3: 'Solutions de traitement d\'eau',
    sagisaBenefit4: 'Ingénierie sur mesure',
    imerysDescription: 'Leader mondial des solutions spécialisées à base de minéraux pour l\'industrie. Imerys fournit de la terre de diatomées et des adjuvants de filtration à base de perlite pour les applications alimentaires, de boissons et industrielles.',
    imerysBenefit1: 'Filtration à base de minéraux',
    imerysBenefit2: 'Produits de qualité alimentaire',
    imerysBenefit3: 'Performance éprouvée',
    imerysBenefit4: 'Support technique',
    filtroxDescription: 'Fabricant spécialisé de media de filtration et de consommables de filtration industriels. CARLSON FILTROX fournit des plaques filtrantes, des cartouches filtrantes et des sacs filtrants de haute qualité pour diverses applications industrielles.',
    filtroxBenefit1: 'Media de filtration de qualité',
    filtroxBenefit2: 'Large gamme de produits',
    filtroxBenefit3: 'Expertise industrielle',
    filtroxBenefit4: 'Performance fiable',
    threeMDescription: 'Entreprise d\'innovation mondiale fournissant des systèmes de filtration d\'eau haute performance. 3M propose des solutions de filtration avancées pour les applications résidentielles, commerciales et de restauration.',
    threeMBenefit1: 'Leader de l\'innovation',
    threeMBenefit2: 'Technologie avancée',
    threeMBenefit3: 'Support mondial',
    threeMBenefit4: 'Fiabilité éprouvée',
    msDescription: 'Fabricant spécialisé de la production de milieux microbiologiques pour les applications de laboratoire et industrielles. M & S fournit des ensembles de coussinets nutritifs de haute qualité pour le contrôle qualité et la recherche.',
    msBenefit1: 'Expertise en milieux de culture',
    msBenefit2: 'Solutions de contrôle qualité',
    msBenefit3: 'Standards de laboratoire',
    msBenefit4: 'Excellence technique',
    industryWaterTreatment: 'Traitement de l\'Eau',
    industryIndustrialProcessing: 'Transformation Industrielle',
    industryCommercial: 'Commercial',
    industryResidential: 'Résidentiel',
    industryFoodBeverage: 'Agroalimentaire & Boissons',
    industryBrewing: 'Brasserie',
    industryWineProduction: 'Production de Vin',
    industryHealthcare: 'Santé',
    industryLaboratoryServices: 'Services de Laboratoire',
    industryQualityControl: 'Contrôle Qualité',
    industryResearchDevelopment: 'Recherche & Développement',
    industryBiotechnology: 'Biotechnologie',
    industryFoodService: 'Restauration',
    industryMining: 'Mines',
    industryOilGas: 'Pétrole & Gaz',
    industryPharmaceutical: 'Pharmaceutique',
  },
};